export default "__VITE_ASSET__B4K8yQ4N__"